import type { Cart } from "@graphql/generated/types";

// Products restricted from express shipping due to hazardous material regulations (GB only).
const NON_EXPRESS_DELIVERY_PRODUCTS = new Set([
    "903399200100",
    "904010700100",
    "904011100100",
    "904011900100",
    "904016700100",
    "904012900100",
    "904016500100",
    "904016400100",
    "903310100100",
    "903310200100",
    "903310300100",
    "903310500100",
    "903320100100",
    "903395400100",
    "903395500100",
    "903395600101",
    "903398500100",
    "903398700100",
    "903398900100",
    "903399000100",
    "903399190146",
    "903310400100",
    "903400900100",
    "904012100100",
    "904012300100",
    "904013900100",
    "904010400100",
]);

export const cartContainsNonExpressProducts = (cart: Cart | null | undefined): boolean => {
    if (!cart?.lineItems) return false;
    return cart.lineItems.some(
        (lineItem) =>
            lineItem.productKey != null && NON_EXPRESS_DELIVERY_PRODUCTS.has(lineItem.productKey)
    );
};
